export default __webpack_public_path__ + "static/media/clipboard.24234b14.svg";